import { reportError } from '../observability';

/**
 * Logs an error to the console and reports it through the vendor-neutral
 * observability facade, which fans out to every registered sink (e.g. Datadog +
 * LogRocket). Signature preserved for existing call sites.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logError = (error: any, extra: any = null) => {
  console.error(error);
  reportError(error, extra ?? undefined);
};
